import React from "react";
import MainFeaturesForm from "./dialog-forms/MainFeaturesForm";
import RoundedButton from "../../../../shared/components/buttons/RoundedButton";
import RoomsForm from "./dialog-forms/RoomsForm";
import OtherFeaturesForm from "./dialog-forms/OtherFeaturesForm";
import NearbyLocationsForm from "./dialog-forms/NearbyLocationsForm";
import { useFormContext } from "react-hook-form";
import { EMPTY_STRING } from "../../../../constants";

const MainContainer = ({ selectedFeature, onSubmit }) => {
  const { handleSubmit, watch } = useFormContext();

  const formValues = watch("amenity") ?? {};

  const isDisabled = Object.values(formValues).every(
    (value) =>
      value === "" ||
      value === null ||
      value === undefined ||
      (Array.isArray(value) && value.length === 0)
  );
  return (
    <div className="main-container">
      <form onSubmit={handleSubmit(onSubmit)}>
        {selectedFeature === 1 && <MainFeaturesForm />}
        {selectedFeature === 2 && <RoomsForm />}
        {selectedFeature === 3 && <OtherFeaturesForm />}
        {selectedFeature === 4 && <NearbyLocationsForm />}
        <div className="d-flex justify-content-center">
          <RoundedButton
            className={`mt-4 py-2 px-5 ${
              isDisabled ? "not-allowed" : EMPTY_STRING
            }`}
            type="submit"
            disabled={isDisabled}
          >
            Add
          </RoundedButton>
        </div>
      </form>
    </div>
  );
};

export default MainContainer;
